import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import CONSTANTS from '../../_constants/constants';

import { SharedModule } from '../../_shared/shared.module';
import { AbilityService } from '../../_shared/services/ability.service';
import { DataService } from '../../_shared/services/data.service';
import { UtilService } from '../../_shared/services/util.service';

import { WhatToBring } from '../shared/what-to-bring.model';
import { WhatToBringService } from '../shared/what-to-bring.service';

@Component({
  selector: 'app-what-to-bring-list',
  templateUrl: './what-to-bring-list.component.html',
  standalone: true,
  imports: [SharedModule],
})
export class WhatToBringListComponent implements OnInit, OnDestroy {
  constructor(
    private whatToBringService: WhatToBringService,
    private abilityService: AbilityService,
    private dataService: DataService,
    public utilService: UtilService
  ) {}

  @Input() whatToBrings: WhatToBring[];
  @Input() meta;
  @Input() loadingWhatToBrings: boolean;
  @Input() defaultLanguage;

  @Output() private selectedWhatToBring = new EventEmitter<{
    whatToBring: WhatToBring;
    mode: string;
  }>();

  permissions = {
    canShow: this.abilityService.can('show_whattobring_accountadmin'),
    canUpdate: this.abilityService.can('update_whattobring_accountadmin'),
    canDestroy: this.abilityService.can('destroy_whattobring_accountadmin'),
  };

  productTypes = CONSTANTS.ALL_PRODUCT_TYPES;

  filterCriteria = this.whatToBringService.getFilterCriteria();

  masterCheckboxSelected = false;
  showListActions = false;
  totalItemsSelected = 0;

  private $subs: Subscription;

  ngOnInit() {
    this.$subs = this.utilService.getCheckboxsSubjectValue().subscribe((data) => {
      this.showListActions = data.showListActions;
      this.totalItemsSelected = data.totalItemsSelected;
      this.masterCheckboxSelected = data.masterCheckboxSelected;
    });
  }

  ngOnDestroy() {
    if (this.$subs) {
      this.$subs.unsubscribe();
    }
  }

  reloadWhatToBrings() {
    this.filterCriteria = this.whatToBringService.getFilterCriteria();

    this.getWhatToBrings();
  }

  // Referenced from app-search-text-input
  onSearched({ field, value }) {
    this.filterWhatToBrings(field, value);
  }

  filterWhatToBrings(field, value) {
    this.filterCriteria = this.utilService.setFilterCriteria(this.filterCriteria, field, value);

    this.getWhatToBrings();
  }

  // Referenced from app-sort-by
  onSorted({ sortBy, sortDir }) {
    this.filterCriteria.page = 1;
    this.filterCriteria.sortDir = sortDir;
    this.filterCriteria.sortedBy = sortBy;

    this.getWhatToBrings();
  }

  // Referenced from app-table-footer
  onSelectedPage({ page, offset }) {
    this.filterCriteria.page = page;
    this.filterCriteria.offset = offset;

    this.getWhatToBrings();
  }

  selectWhatToBring(whatToBring: WhatToBring, mode = '') {
    if (!this.permissions.canShow) return;

    this.selectedWhatToBring.emit({ whatToBring, mode });
  }

  // Referenced from app-list-actions
  onUpdatedItems(option) {
    let successCallback = () => {
      this.getWhatToBrings();
    };

    this.dataService.changeItemsStatus(
      'what_to_brings',
      this.whatToBrings,
      option,
      successCallback
    );
  }

  // Referenced from app-list-actions
  onDeletedItems() {
    let successCallback = () => {
      this.getWhatToBrings();
    };

    this.dataService.deleteItems('what_to_brings', this.whatToBrings, successCallback);
  }

  changeWhatToBringStatus(whatToBring: WhatToBring) {
    let successCallback = () => {
      this.utilService.changeItemRowStyle(whatToBring.id);
    };

    this.dataService.changeItemStatus('what_to_brings', whatToBring, successCallback, {});
  }

  deleteWhatToBring(whatToBring: WhatToBring) {
    let successCallback = () => {
      this.getWhatToBrings();
    };

    const params = {
      title: 'DELETE_FACILITY',
      message: 'SURE_TO_DELETE_FACILITY',
      reason: 'DELETE_ITEM_REASON',
      requireConfirmation: true,
      successMsg: 'DELETED_FACILITY',
    };

    this.dataService.deleteItem('what_to_brings', whatToBring, successCallback, params);
  }

  private getWhatToBrings() {
    this.filterCriteria.lang = this.defaultLanguage.lang;

    this.loadingWhatToBrings = true;
    this.whatToBringService.getWhatToBrings(this.filterCriteria).subscribe((response) => {
      this.whatToBrings = response.data;
      this.meta = response.meta;

      this.loadingWhatToBrings = false;
    });
  }
}
